import React, { useEffect, useState } from "react";
import { Col, Row, Button, Spinner, Alert, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import {
  sendSMS,
  getBookingByID,
  getCurrentUserDetails,
  getListingByBookingId,
  getInquiryDataById,
  getListingByID,
  getUserByID,
  getWaiverDataByName,
  sendEmail,
  tripCompletedEmailBody,
  tripStatusUpdateEmailBody,
  getPaymentById,
  isOffPlatformDeposit,
  isInspectionChargeAnswer,
} from "../utils";
import {
  notifyTripEndedForRenter,
} from "../utils/userNotifications";
import {
  get,
  getDatabase,
  push,
  ref,
  serverTimestamp,
  set,
  update,
} from "firebase/database";
import SignatureCanvas from "react-signature-canvas";

const FUEL_SURCHARGE_QUESTION = {
  question: "Fuel surcharge",
  type: "options",
  options: ["All Good", "Charge fuel surcharge"],
  required: "true",
};

const CLEANING_QUESTION = {
  question: "Cleaning",
  type: "options",
  options: ["All Good", "Charge for cleaning"],
  required: "true",
};

const isTripChargeQuestion = (question = "") => {
  const text = String(question).toLowerCase();
  return text.includes("fuel surcharge") || text === "cleaning";
};

const ensureTripChargeQuestionsFirst = (questions = []) => {
  const remainingQuestions = questions.filter(
    (question) => !isTripChargeQuestion(question?.question)
  );

  const fuelQuestion =
    questions.find((question) =>
      String(question?.question || "").toLowerCase().includes("fuel surcharge")
    ) || FUEL_SURCHARGE_QUESTION;

  const cleaningQuestion =
    questions.find(
      (question) =>
        String(question?.question || "").toLowerCase() === "cleaning"
    ) || CLEANING_QUESTION;

  return [fuelQuestion, cleaningQuestion, ...remainingQuestions];
};

const getTripCompletionLinks = (bookingId) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  return {
    tipLink: `${baseUrl}/tip/${bookingId}`,
    reviewLink: `${baseUrl}/dashboard/event/${bookingId}`,
  };
};

const isRenterDrivingTrip = (boatDetails, inquiryData) => {
  const offer = inquiryData?.offerData;
  if (offer?.captainCheckbox) return false;
  if (
    boatDetails?.boatType === "Fishing Guide" ||
    boatDetails?.boatType === "Fishing Charter"
  ) {
    return false;
  }
  if (boatDetails?.boatCaptain === true) return false;
  return true;
};

const getPostTripOwnerGuidanceMessage = (
  boatDetails,
  inquiryData,
  paymentDetails
) => {
  if (
    isRenterDrivingTrip(boatDetails, inquiryData) &&
    !isOffPlatformDeposit(paymentDetails)
  ) {
    return [
      'If you inspected the boat and All Good, proceed to cancel the renter\'s credit card hold. Once the hold is cancelled, you can withdraw your payment using the "Request Withdrawal" button under "Payments".',
      "If you did find an issue, a fuel surcharge, or a cleaning charge, you have 7 days to provide repair invoices to the renter and charge the renter's credit card accordingly, please message the renter to keep them informed.",
    ];
  }

  return [
    'You can withdraw your payment using the "Request Withdrawal" button under "Payments".',
  ];
};

const sendRenterTripCompletedNotifications = async ({
  renterId,
  renterData,
  renterName,
  renterEmail,
  bookingTitle,
  bookingId,
  hasIssue = false,
}) => {
  const { tipLink, reviewLink } = getTripCompletionLinks(bookingId);
  const subject = "Your trip is now complete";

  const emailRenterBody = await tripCompletedEmailBody(
    renterName,
    bookingTitle,
    null,
    bookingId
  );
  sendEmail(renterEmail, subject, emailRenterBody);
console.log('renterData.....', renterData)
  const renterSmsBody = `Your trip for ${bookingTitle} is now complete. Leave a tip: ${tipLink} Review your experience: ${reviewLink}`;
  await sendSMS(renterData.phone, renterSmsBody);

  if (renterId) {
    notifyTripEndedForRenter(bookingId, { hasIssue }).catch((err) =>
      console.error("Failed to create renter notification:", err)
    );
  }
};

export default function EndTrip() {
  const { dynamicId } = useParams();
  const navigate = useNavigate();
  const [formResponses, setFormResponses] = useState([]);
  const [waiverQuestions, setWaiverQuestions] = useState([]);
  const [userData, setUserData] = useState([]);
  const signatureRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const [signatureDateTime, setSignatureDateTime] = useState("");

  const handleSignatureBegin = () => {
    if (!signatureDateTime) {
      const now = new Date();
      setSignatureDateTime(
        now.toLocaleString("en-US", {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
      );
    }
  };
  const [isFishingCharter, setIsFishingCharter] = useState(false);
  const [boatDetails, setBoatDetails] = useState(null);
  const [bookingData, setBookingData] = useState(null);
  const [inquiryData, setInquiryData] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [showTripReturnedGuidanceModal, setShowTripReturnedGuidanceModal] =
    useState(false);
  const tripReturnedOwnerGuidanceStorageKey = `tripReturnedOwnerGuidanceSeen_${dynamicId}`;

  const closeTripReturnedGuidanceModal = () => {
    localStorage.setItem(tripReturnedOwnerGuidanceStorageKey, "1");
    setShowTripReturnedGuidanceModal(false);
  };

  const handleImageUpload = async (question, files) => {
    const formData = new FormData();

    console.log("image upload");

    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/upload-images`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        const data = await response.json();
        const filenames = data.file_names;

        const existingResponseIndex = formResponses.findIndex(
          (response) => response.Question === question
        );

        if (existingResponseIndex !== -1) {
          const updatedResponses = [...formResponses];
          updatedResponses[existingResponseIndex].Answer =
            question === "Picture" ? filenames[0] : filenames;
          setFormResponses(updatedResponses);
        } else {
          setFormResponses([
            ...formResponses,
            {
              Question: question,
              Answer: question === "Picture" ? filenames[0] : filenames,
            },
          ]);
        }
      } else {
        console.error("Error uploading images:", response.statusText);
      }
    } catch (error) {
      console.error("Error uploading images:", error);
    }
  };

  const handleSaveSignature = () => {
    if (signatureRef.current.isEmpty()) {
      console.error("Signature is empty");
      return;
    }

    const signatureImage = signatureRef.current
      .getTrimmedCanvas()
      .toDataURL("image/png");
    const signatureFile = dataURLtoFile(signatureImage, "signature.png");
    handleImageUpload("Signature", [signatureFile]);
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  // Initialize an array to track checked questions
  const checkedQuestions = [];

  const handleInputChange = (question, answer) => {
    if (question === "date" || question === "country") {
      // Handle date and country inputs
      const updatedResponses = [...formResponses];
      const existingResponseIndex = updatedResponses.findIndex(
        (response) => response.Question === question
      );

      if (existingResponseIndex !== -1) {
        updatedResponses[existingResponseIndex].Answer = answer;
      } else {
        updatedResponses.push({ Question: question, Answer: answer });
      }

      setFormResponses(updatedResponses);
    } else {
      const existingResponseIndex = formResponses.findIndex(
        (response) => response.Question === question
      );

      if (existingResponseIndex !== -1) {
        const updatedResponses = [...formResponses];
        updatedResponses[existingResponseIndex].Answer = answer;
        setFormResponses(updatedResponses);
      } else {
        setFormResponses([
          ...formResponses,
          { Question: question, Answer: answer },
        ]);
      }

      if (
        answer === "Checked" ||
        answer === `There's an issue` ||
        answer === `Yes`
      ) {
        if (!checkedQuestions.includes(question)) {
          const newImageQuestion = {
            question: "Picture",
            type: "images",
            id: question + 1,
          };
          const updatedWaiverQuestions = [
            ...waiverQuestions.slice(0, question + 1),
            newImageQuestion,
            ...waiverQuestions.slice(question + 1),
          ];
          const shiftedWaiverQuestions = updatedWaiverQuestions.map(
            (item, index) => ({ ...item, id: index })
          );

          setWaiverQuestions(shiftedWaiverQuestions);
          checkedQuestions.push(question);
          console.log(checkedQuestions);
        }
      } else {
        // Remove the image question if the option is unchecked
        const questionIndex = question;

        console.log("cancelled");
        if (
          questionIndex !== -1 &&
          questionIndex < waiverQuestions.length - 1
        ) {
          const nextQuestion = waiverQuestions[questionIndex + 1].question;
          console.log("nextQuestion");
          console.log(nextQuestion);

          // Check if the next question is not "Please take a picture of it"
          if (nextQuestion == "Picture") {
            // Remove the image question by updating waiverQuestions
            const updatedWaiverQuestions = waiverQuestions.filter(
              (item, index) => index !== questionIndex + 1
            );
            const shiftedWaiverQuestions = updatedWaiverQuestions.map(
              (item, index) => ({ ...item, id: index })
            );
            setWaiverQuestions(shiftedWaiverQuestions);
          }
        }
      }
    }
  };

  const saveSignature = () => {
    if (signatureRef.current.isEmpty()) {
      console.error("Signature is empty");
      return;
    }

    const signatureImage = signatureRef.current
      .getTrimmedCanvas()
      .toDataURL("image/png");

    handleImageUpload("Signature", [
      dataURLtoFile(signatureImage, "signature.png"),
    ]);
  };

  const handlePrefillAllGood = (event) => {
    if (event) {
      event.preventDefault();
    }

    const prefilledResponses = waiverQuestions
      .filter(
        (question) =>
          question.options &&
          question.type !== "signature" &&
          question.type !== "images" &&
          question.type !== "text" &&
          question.type !== "date" &&
          question.type !== "country"
      )
      .map((question) => ({
        Question: question.id,
        Answer: question.question === "Motor Hour Gauge" ? "" : "All Good",
      }));

    setFormResponses(prefilledResponses);
  };

  const allGood = (event) => {
    handlePrefillAllGood(event);
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true); // Add a loading state if you don't have one
    console.log('Trip completion started')
    try {
      // Define the path in the Firebase database
      const database = getDatabase();
      const tripDataRef = ref(
        database,
        `bookings/${dynamicId}/tripData/waivers/${userData.role} Equipment Checklist`
      );
  
      // Create an array to store the question-answer pairs
      const questionsArray = formResponses.map((response) => {
        let answer;
        if (response.type === "signature") {
          answer = response.Answer[0];
        } else if (response.type === "images") {
          // For images, use an array of URLs
          answer = response.Answer.map((image) => ({ url: image }));
        } else {
          // For other types, use the answer directly
          answer = response.Answer;
        }
  
        return {
          question:
            waiverQuestions.find((q) => q.id === response.Question)?.question ||
            response.Question,
          answer,
        };
      });
  
      // Save the array of question-answer pairs to Firebase under the 'questions' field
      await push(tripDataRef, {
        waiverName: "Boat Owner Equipment Checklist",
        questions: questionsArray,
        signedAt: serverTimestamp(),
      });
  
      // Peer rentals stay Trip Returned until Cancel Hold / charge releases the deposit
      const bookingRef = ref(database, `bookings/${dynamicId}`);
      await update(bookingRef, { status: "Trip Returned" });
  
      const hasInspectionIssues = formResponses.some((response) =>
        isInspectionChargeAnswer(response.Answer)
      );

      // Update trip data with end timestamp
      const tripData = ref(database, `bookings/${dynamicId}/tripData`);
      await update(tripData, {
        endTimestamp: serverTimestamp(),
        inspectionAllGood: !hasInspectionIssues,
      });
  
      console.log("Form responses saved to Firebase:", questionsArray);
  
      // Get booking data
      const bookingData = await getBookingByID(dynamicId);
      
      // Process owner payment
      if (bookingData.paymentId) {
        try {
          // Get payment details
          const paymentRef = ref(database, `payments/${bookingData.paymentId}`);
          const paymentSnapshot = await get(paymentRef);
          const payment = paymentSnapshot.val();
          
          if (payment) {
            // Get owner details and booking count for calculation
            const ownerData = await getUserByID(bookingData.owner);
            const totalOwnerBookings = ownerData.totalPaidBookings || 0;
            
            // Update payment status
            await update(paymentRef, {
              status: 'completed',
              tripCompleted: true,
              tripCompletedAt: serverTimestamp(),
              scheduledPayoutDate: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString() // tomorrow
            });
            
            // Process owner payment
            // Use the already calculated owner amount for standard payments
            let dbOwnerAmount = payment.ownerAmount;
  
            // FEATURE 2: Special handling for first-time owner low-value bookings
            if (payment.firstTimeSpecialRate && payment.specialAdminRate) {
              console.log("Processing special first-time owner low-value booking");
              // The admin fee was already calculated at 50% in the initial payment processing
              // The dbOwnerAmount should already be correct
            }
            
            // For charter deposits with cash balance at meetup, include the cash collected by owner
            if (payment.charterDeposit && payment.collectBalanceAtMeetup) {
              const cashBalance = payment.charterCashBalance || payment.charterRemainingBalance || 0;
              dbOwnerAmount += cashBalance;
              console.log("Charter deposit with cash at meetup - adding cash balance:", cashBalance);
            }
            
            const ownerMetaPayments = ref(database, `ownerMeta/${bookingData.owner}`);
            
            const previousOwnerPaymentsSnapshot = await get(ownerMetaPayments);
            if (previousOwnerPaymentsSnapshot.exists()) {
              const previousOwnerPayments = previousOwnerPaymentsSnapshot.val();
              const previousCurrentAmount = previousOwnerPayments.payments.currentAmount;
              const previousTotalAmount = previousOwnerPayments.payments.totalAmount;
              const ownerPayments = {
                currentAmount: previousCurrentAmount + dbOwnerAmount,
                totalAmount: previousTotalAmount + dbOwnerAmount,
              };
              console.log("Updated owner payments:", ownerPayments);
              
              if (previousOwnerPayments.previousTotalAmount) {
                const updatedTotalPaidBookings = parseInt(previousOwnerPayments.previousTotalAmount) + 1;
                await update(ownerMetaPayments, {
                  payments: ownerPayments,
                  totalPaidBookings: updatedTotalPaidBookings,
                });
              } else {
                await update(ownerMetaPayments, {
                  payments: ownerPayments,
                  totalPaidBookings: 1,
                });
              }
            } else {
              const ownerPayments = {
                currentAmount: dbOwnerAmount,
                totalAmount: dbOwnerAmount,
              };
              console.log("Created new owner payments:", ownerPayments);
              
              await update(ownerMetaPayments, {
                payments: ownerPayments,
                totalPaidBookings: 1,
              });
            }
            
            console.log("Owner payment processed successfully");
          }
        } catch (paymentError) {
          console.error("Error processing owner payment:", paymentError);
          // Continue with trip completion even if payment processing fails
        }
      }
      
      // Send notifications
      const userName = userData.firstName + " " + userData.lastName;
      const bookingTitle = bookingData.listingTitle;
      const subject = "Congratulations! Your trip is now returned";
      const userEmail = userData.email;
  
      const emailBody = await tripStatusUpdateEmailBody(
        userName,
        bookingData.listingTitle,
        "Trip Returned"
      );
      sendEmail(userEmail, subject, emailBody);
  
      const renterData = await getUserByID(bookingData.renter);
      const renterName = renterData.firstName + " " + renterData.lastName;
      const renterEmail = renterData.email;

      await sendRenterTripCompletedNotifications({
        renterId: bookingData.renter,
        renterData,
        renterName,
        renterEmail,
        bookingTitle,
        bookingId: dynamicId,
        hasIssue: hasInspectionIssues,
      });
  
      setLoading(false); // Turn off loading
      if (hasInspectionIssues) {
        navigate(`/dashboard/event/${dynamicId}`, {
          state: { showDamageClaimModal: true },
        });
      } else {
        navigate(`/dashboard/event/${dynamicId}`, {
          state: { showAllGoodConfirmation: true },
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false); // Turn off loading on error
    }
  };

  useEffect(() => {
    const fetchWaiverData = async () => {
      try {
        // Get booking data
        const booking = await getBookingByID(dynamicId);
        setBookingData(booking);
        
        // Get current user details
        const currentUserDetails = await getCurrentUserDetails();
        setUserData(currentUserDetails);
        
        // Get listing details
        const listing = await getListingByID(booking.listingId);
        setBoatDetails(listing);
        
        // Get inquiry details if available
        let inquiry = null;
        if (booking.inquiryId) {
          inquiry = await getInquiryDataById(booking.inquiryId);
          setInquiryData(inquiry);
        }

        if (booking.paymentId) {
          const payment = await getPaymentById(booking.paymentId);
          setPaymentDetails(payment);
        }

        // Determine if this is a fishing charter/guide with captain
        const isCaptainedFishingTrip =
          (listing?.boatType === "Fishing Guide" ||
            listing?.boatType === "Fishing Charter" ||
            listing?.boatCaptain === true ||
            inquiry?.offerData?.captainCheckbox === true) &&
          currentUserDetails.role === "Boat Owner";

        setIsFishingCharter(isCaptainedFishingTrip);

        if (
          !isCaptainedFishingTrip &&
          currentUserDetails.role === "Boat Owner" &&
          !localStorage.getItem(tripReturnedOwnerGuidanceStorageKey)
        ) {
          setShowTripReturnedGuidanceModal(true);
        }
        
        // Only fetch waiver questions if not a fishing charter
        if (!isCaptainedFishingTrip) {
          const waiverName = "Rental Return Multi Point Inspection";
          const questions = (await getWaiverDataByName(waiverName)) || [];
          const questionsWithId = ensureTripChargeQuestionsFirst(questions).map(
            (question, index) => ({
              ...question,
              id: index,
            })
          );
          setWaiverQuestions(questionsWithId);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchWaiverData();
  }, [dynamicId]);

  console.log(waiverQuestions);

  // Function to handle direct end trip for fishing charters
  const handleDirectEndTrip = async () => {
    setLoading(true);
    try {
      // Define the path in the Firebase database
      const database = getDatabase();
      
      // Update booking status
      const bookingRef = ref(database, `bookings/${dynamicId}`);
      await update(bookingRef, { status: "Trip Concluded" });
      
      // Update trip data with end timestamp
      const tripData = ref(database, `bookings/${dynamicId}/tripData`);
      await update(tripData, {
        endTimestamp: serverTimestamp(),
        inspectionAllGood: true,
      });
      
      // Process owner payment
      if (bookingData.paymentId) {
        try {
          // Get payment details
          const paymentRef = ref(database, `payments/${bookingData.paymentId}`);
          const paymentSnapshot = await get(paymentRef);
          const payment = paymentSnapshot.val();
          
          if (payment) {
            // Update payment status
            await update(paymentRef, {
              status: 'completed',
              tripCompleted: true,
              tripCompletedAt: serverTimestamp(),
              scheduledPayoutDate: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString() // tomorrow
            });
            
            // Process owner payment
            // For charter deposits with cash balance at meetup, include the cash collected by owner
            let dbOwnerAmount = payment.ownerAmount || 0;
            if (payment.charterDeposit && payment.collectBalanceAtMeetup) {
              const cashBalance = payment.charterCashBalance || payment.charterRemainingBalance || 0;
              dbOwnerAmount += cashBalance;
              console.log("Charter deposit with cash at meetup - adding cash balance:", cashBalance);
            }
            const ownerMetaPayments = ref(database, `ownerMeta/${bookingData.owner}`);
            
            const previousOwnerPaymentsSnapshot = await get(ownerMetaPayments);
            if (previousOwnerPaymentsSnapshot.exists()) {
              const previousOwnerPayments = previousOwnerPaymentsSnapshot.val();
              const previousCurrentAmount = previousOwnerPayments.payments.currentAmount;
              const previousTotalAmount = previousOwnerPayments.payments.totalAmount;
              const ownerPayments = {
                currentAmount: previousCurrentAmount + dbOwnerAmount,
                totalAmount: previousTotalAmount + dbOwnerAmount,
              };
              
              if (previousOwnerPayments.previousTotalAmount) {
                const updatedTotalPaidBookings = parseInt(previousOwnerPayments.previousTotalAmount) + 1;
                await update(ownerMetaPayments, {
                  payments: ownerPayments,
                  totalPaidBookings: updatedTotalPaidBookings,
                });
              } else {
                await update(ownerMetaPayments, {
                  payments: ownerPayments,
                  totalPaidBookings: 1,
                });
              }
            } else {
              const ownerPayments = {
                currentAmount: dbOwnerAmount,
                totalAmount: dbOwnerAmount,
              };
              
              await update(ownerMetaPayments, {
                payments: ownerPayments,
                totalPaidBookings: 1,
              });
            }
          }
        } catch (paymentError) {
          console.error("Error processing owner payment:", paymentError);
          // Continue with trip completion even if payment processing fails
        }
      }
      
      // Send notifications
      const userName = userData.firstName + " " + userData.lastName;
      const bookingTitle = bookingData.listingTitle;
      const subject = "Congratulations! Your trip is now returned";
      const userEmail = userData.email;
      
      const statusText = isFishingCharter ? "Trip Concluded" : "Trip Returned";
      const emailBody = await tripStatusUpdateEmailBody(
        userName,
        bookingData.listingTitle,
        statusText
      );
      sendEmail(userEmail, subject, emailBody);
      
      // Get renter data and send review/tip request
      const renterData = await getUserByID(bookingData.renter);
      const renterName = renterData.firstName + " " + renterData.lastName;
      const renterEmail = renterData.email;

      await sendRenterTripCompletedNotifications({
        renterId: bookingData.renter,
        renterData,
        renterName,
        renterEmail,
        bookingTitle,
        bookingId: dynamicId,
        hasIssue: false,
      });
      
      setLoading(false);
      navigate(`/dashboard/event/${dynamicId}`);
    } catch (error) {
      console.error("Error ending trip:", error);
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        centered
        show={showTripReturnedGuidanceModal}
        onHide={closeTripReturnedGuidanceModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Trip Returned!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {getPostTripOwnerGuidanceMessage(
            boatDetails,
            inquiryData,
            paymentDetails
          ).map((paragraph, index, paragraphs) => (
            <p
              key={index}
              className={index === paragraphs.length - 1 ? "mb-0" : "mb-3"}
            >
              {paragraph}
            </p>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={closeTripReturnedGuidanceModal}>
            Got it
          </Button>
        </Modal.Footer>
      </Modal>

      <Row className="card p-5 d-flex flex-row align-items-center">
        <Col xs={4}>
          <img
            className="img-fluid"
            src="/assets/backend/images/logo.png"
            style={{backgroundColor:"#121212"}}
            alt="BBR Logo"
          />
        </Col>
        <Col xs={8}>
          <h3
            className=""
            style={{ color: "#27313F", fontWeight: "800", textAlign: "center" }}
          >
            BBR BASS BOAT RENTALS, LLC
          </h3>
        </Col>
      </Row>
      
      {isFishingCharter ? (
        // Simplified UI for fishing charters with captain
        <>
          <div className="row">
            <div className="col">
              <div className="page-description">
                <h1>End Trip</h1>
              </div>
            </div>
          </div>
          
          <Row>
            <Col>
              <div className="card p-4">
                <Alert variant="info">
                  <p>You're about to end this fishing charter trip. Once you click "End Trip", the trip will be marked as completed.</p>
                  <p>A message will be sent to the customer.</p>
                </Alert>
                
                <div className="d-flex justify-content-center mt-4">
                  <Button 
                    variant="primary" 
                    size="lg" 
                    onClick={handleDirectEndTrip}
                    disabled={loading}
                    className="px-5 py-3"
                  >
                    {loading ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        <span className="ms-2">Processing...</span>
                      </>
                    ) : (
                      "End Trip"
                    )}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </>
      ) : (
        // Original UI for regular boat rentals
        <>
          <div className="row">
            <div className="col">
              <div className="page-description">
                <h1>Rental Return Multi Point Inspection</h1>
              </div>
            </div>
          </div>

          <Row>
            <Col>
              <div className="card p-4">
                <button className="btn btn-primary" onClick={allGood} disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                      <span className="ms-2">Processing...</span>
                    </>
                  ) : (
                    "Mark All Good"
                  )}
                </button>
                <p className="text-muted mt-2 mb-3" style={{ fontSize: "14px" }}>
                  Marks every item as All Good, including fuel surcharge and
                  cleaning. For fuel or cleaning charges, you can charge directly
                  after submitting. For any other issue, submit a claim for renter
                  approval.
                </p>
                <form onSubmit={handleSubmit}>
                  {waiverQuestions.map((questionData) => (
                    <div key={`${questionData.question}-${questionData.id}`}>
                      <label className="form-label form-label mt-2">
                        {questionData.question}:
                      </label>
                      <br />
                      {questionData.type === "text" ? (
                        <input
                          required={
                            questionData?.required &&
                            questionData?.required == "true"
                              ? true
                              : false
                          }
                          type="text"
                          className="form-control form-control"
                          value={
                            formResponses.find(
                              (response) => response.Question === questionData.id
                            )?.Answer || ""
                          }
                          onChange={(e) =>
                            handleInputChange(questionData.id, e.target.value)
                          }
                        />
                      ) : questionData.type === "images" ? (
                        <input
                          required={
                            questionData?.required &&
                            questionData?.required == "true"
                              ? true
                              : false
                          }
                          type="file"
                          accept="image/*"
                          capture="camera"
                          multiple
                          onChange={(e) =>
                            handleImageUpload(questionData.id, e.target.files)
                          }
                        />
                      ) : questionData.type === "date" ? (
                        <input
                          required={
                            questionData?.required &&
                            questionData?.required == "true"
                              ? true
                              : false
                          }
                          type="date"
                          className="form-control form-control"
                          value={
                            formResponses.find(
                              (response) => response.Question === "date"
                            )?.Answer || ""
                          }
                          onChange={(e) =>
                            handleInputChange("date", e.target.value)
                          }
                        />
                      ) : questionData.type === "country" ? (
                        <select
                          required={
                            questionData?.required &&
                            questionData?.required == "true"
                              ? true
                              : false
                          }
                          className="form-control"
                          name="settingsInputCountry"
                          value={
                            formResponses.find(
                              (response) => response.Question === "country"
                            )?.Answer || ""
                          }
                          onChange={(e) =>
                            handleInputChange("country", e.target.value)
                          }
                        >
                          <option>United States</option>
                          {/* Add other country options if needed */}
                        </select>
                      ) : questionData.type === "signature" ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
                          <SignatureCanvas
                            ref={signatureRef}
                            onBegin={handleSignatureBegin}
                            required={
                              questionData?.required &&
                              questionData?.required == "true"
                                ? true
                                : false
                            }
                            canvasProps={{
                              width: 500,
                              height: 200,
                              className: "sigCanvas",
                            }}
                          />
                          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "12px" }}>
                            <button
                              type="button"
                              onClick={() => {
                                signatureRef.current.clear();
                                setSignatureDateTime("");
                              }}
                              className="btn btn-primary"
                            >
                              Clear
                            </button>
                            {signatureDateTime && (
                              <span style={{ fontSize: "13px", fontWeight: "600", color: "#27313F" }}>
                                ✅ Signed: {signatureDateTime}
                              </span>
                            )}
                          </div>
                        </div>
                      ) : (
                        questionData.options.map((option) => (
                          <div
                            className="btn btn-light m-1 mb-4 form-check"
                            key={option}
                          >
                            <label htmlFor={option} className="form-check-label">
                              {option}
                            </label>
                            <input
                              required={
                                questionData?.required &&
                                questionData?.required == "true"
                                  ? true
                                  : false
                              }
                              type="radio"
                              name={questionData.id}
                              value={option}
                              id={questionData.id}
                              className="form-check-input"
                              checked={
                                formResponses.find(
                                  (response) =>
                                    response.Question === questionData.id
                                )?.Answer === option
                              }
                              onChange={() =>
                                handleInputChange(questionData.id, option)
                              }
                            />
                          </div>
                        ))
                      )}
                    </div>
                  ))}
                  <button type="submit" className="btn btn-primary mt-3" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        <span className="ms-2">Processing...</span>
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </form>
              </div>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}
